export function formatDate (datestring: string, locale: Intl.LocalesArgument = 'en', options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }) {
  if (!datestring) return
  const date = new Date(datestring)
  return date.toLocaleDateString(locale, options)
}

export function getFullYear (date?: string) {
  return (date ? new Date(date) : new Date()).getFullYear()
}

export function getAssetURL (filepath: string): string {
  return new URL(`../assets/${filepath}`, import.meta.url).href
}

export function groupBy (data: Array<object>, key: string, options?: { fallbackGroup?: string | false, transformer?: (value: object) => unknown }) {
  const {
    fallbackGroup = 'default',
    transformer = (value: object) => value
  } = options || {}

  return data.reduce((acc, item) => {
    const group = typeof item[key] === 'string' ? item[key] : fallbackGroup
    if (group) {
      if (!acc[group]) acc[group] = []
      acc[group].push(transformer(item))
    }
    return acc
  }, {})
}

export function sleep (time: number) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export function memoize (fn) {
  if (typeof fn !== 'function') {
    throw new Error('Memoization not allowed: the argument must be a function')
  }

  const cache = {}

  return function (...args) {
    const key = JSON.stringify(args)

    if (!cache.hasOwnProperty(key)) { // eslint-disable-line
      cache[key] = fn.apply(this, args)
    }

    return cache[key]
  }
}

export function getScrollbarWidth () {
  const body = document.body

  const dummyEl = document.createElement('div')
  dummyEl.style.position = 'fixed'
  dummyEl.style.inset = '0px'
  dummyEl.style.width = '100vw'
  dummyEl.style.visibility = 'hidden'
  dummyEl.style.overflow = 'hidden'
  body.appendChild(dummyEl)

  const width = (dummyEl.offsetWidth - body.clientWidth)

  body.removeChild(dummyEl)

  return width
}
